import { UI, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { FundsApplicationProps } from '../..';
import { InputMoney } from '../../../../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../../../../components/RiskRating';
import { FundsAssetController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/Funds';
import { ProductCard } from '../../../../components/ProductCard';

export interface FundInvestCardProps {
  offer: FundsApplicationProps['offer'];
  offerController: FundsAssetController;
}

export const FundInvestCard: React.FC<FundInvestCardProps> = ({ offer, offerController }) => {
  const id = offer.productIdNormalized;

  const {
    handleInputFocus,
    handleInputClear,
    isFocused,
    handleInputBlur,
    handleSubmit,
    control,
    hasError,
    helpText,
    currentValueFormatted,
  } = offerController;

  return (
    <ProductCard
      infos={[
        { label: 'Tipo', value: offer.productCategoryNormalized },
        { label: 'Rentabilidade 12 meses', value: offer.profitabilityTwelveMonthsNormalized },
        { label: 'Taxa administrativa', value: offer.administrationFeeNormalized },
        { label: 'Resgate', value: offer.quotationRedemptionTermFormattedNormalized },
        {
          label: 'Perfil de risco',
          value: (
            <RiskRating
              currentRiskRating={Number(offer.riskRatingLevelNormalized) || 0}
              tooltip={offer.riskRatingNormalized || ''}
            />
          ),
        },
        {
          label: 'Aplicação mínima',
          value: Utils.Mask.Money(offer.minimumMovimentationNormalized || 0),
        },
      ]}
      captions={offer.captions}
      productColor="product.fundos"
      title={offer.productNameNormalized || offer.productDisplay || '--'}
      BottomComponent={
        <VStack>
          <UI.Text color="neutral.black" variant="semibold">
            Valor a aplicar
          </UI.Text>
          <InputMoney
            id={`fixedIncome-input${id}`}
            name="createAppliedAmount"
            control={control}
            handleFocus={handleInputFocus}
            handleBlur={handleInputBlur}
            handleSubmit={handleSubmit}
            handleClear={handleInputClear}
            currentValue={currentValueFormatted}
            hasFocus={isFocused}
            minValue={offer.minimumMovimentationNormalized}
            customInputProps={{
              ...{ ...(isFocused && hasError && { error: hasError }) },
              ...{ ...(isFocused && !hasError && { helpText }) },
            }}
          />
        </VStack>
      }
    />
  );
};
